(function ($) {
    $(function () {
        let is_mobile = $('body.mobile').length > 0;

        // HOME
        // -------------------------
        let home_slider = $('.home-slick');

        if (home_slider.length > 0) {

            home_slider.slick({
                arrows: true,
                prevArrow: '<i class="ion-ios-arrow-dropleft">',
                nextArrow: '<i class="ion-ios-arrow-dropright">',
                centerMode: false,
                autoplay: true,
                slidesToShow: is_mobile ? 2 : 3,
                slidesToScroll: 1,
            });

        }


        // PHOTO SLIDER
        // -------------------------
        let item_slider = $('.item-slick');

        if (item_slider.length > 0) {

            item_slider.slick({
                arrows: false,
                prevArrow: '<i class="ion-ios-arrow-dropleft">',
                nextArrow: '<i class="ion-ios-arrow-dropright">',
                asNavFor: '.item-slick__nav'
            });

            let item_slider_nav = $('.item-slick__nav');
            item_slider_nav.slick({
                dots: false,
                infinite: false,
                slidesToShow: 10,
                slidesToScroll: 1,
                centerMode: false,
                focusOnSelect: true,
                autoplay: false,
                arrows: false,
                asNavFor: '.item-slick',
                waitForAnimate: false,
                useCSS: false,
                useTransform: false
            }).on('afterChange', (event, slick, currentSlide) => {
                $('.item-slick__title').slick('slickGoTo', currentSlide);
            });
        }

        let item_slider_title = $('.item-slick__title');
        if (item_slider_title.length > 0) {
            item_slider_title.slick({
                dots: false,
                infinite: false,
                slidesToShow: 1,
                centerMode: false,
                focusOnSelect: false,
                autoplay: false,
                arrows: false,
                swipe: false,
                fade: true
            });
        }

        // PHOTO SLIDER
        // -------------------------
        let photo_slick = $('.photo-slide-box__slick');

        if (photo_slick.length > 0) {

            photo_slick.slick({
                arrows: false,
                prevArrow: '<i class="ion-ios-arrow-dropleft">',
                nextArrow: '<i class="ion-ios-arrow-dropright">',
                asNavFor: '.photo-slide-box__nav',
                fade: true
            });

            let photo_slick_nav = $('.photo-slide-box__nav');

            photo_slick_nav.slick({
                dots: false,
                infinite: false,
                slidesToShow: 13,
                slidesToScroll: 1,
                centerMode: false,
                focusOnSelect: true,
                autoplay: false,
                arrows: false,
                asNavFor: '.photo-slide-box__slick',
                waitForAnimate: false,
                useCSS: false,
                useTransform: false
            }).on('afterChange', (event, slick, currentSlide) => {
                $('.photo-slide-box__caption').slick('slickGoTo', currentSlide);
            });

            let photo_slick_caption = $('.photo-slide-box__caption');
            if (photo_slick_caption.length > 0) {
                photo_slick_caption.slick({
                    dots: false,
                    infinite: false,
                    slidesToShow: 1,
                    centerMode: false,
                    focusOnSelect: true,
                    autoplay: false,
                    arrows: false,
                    vertical: true,
                    useTransform: false
                });
            }
        }

        // LITY
        // -------------------------
        $('a[href*="youtube.com"]').on('click',lity);

    });
})(jQuery);